import React from 'react';

const TermsOfService = () => (
  <div className="legal-page">
    <h1>Terms of Service</h1>
    <p><strong>Effective Date:</strong> April 30, 2025</p>

    <p>
      These Terms of Service ("Terms") govern your access to and use of the Snappo LLC website, mobile application, and related services (collectively, the "Services"). By using Snappo, you agree to comply with these Terms. If you do not agree, please do not use our Services.
    </p>

    <hr />
    <h2>1. Eligibility</h2>
    <p>You must be at least 13 years old to use Snappo. By using the Services, you represent and warrant that you meet this age requirement.</p>

    <hr />
    <h2>2. Your Account</h2>
    <p>To use certain features of Snappo, you must create an account. You are responsible for maintaining the confidentiality of your login credentials and for all activities under your account.</p>

    <hr />
    <h2>3. User Content and Uploads</h2>
    <p>You may upload content (photos, videos, voice notes) to the platform in connection with events. By doing so, you:</p>
    <ul>
      <li>Confirm that you own or have permission to upload the content</li>
      <li>Grant Snappo a non-exclusive, royalty-free license to host, display, and allow downloads of that content for the event’s participants and organizers</li>
      <li>Understand that event content may be downloadable unless restricted by the event host</li>
    </ul>

    <p>Snappo is not responsible for content shared or downloaded by users. You agree not to upload any content that:</p>
    <ul>
      <li>Is illegal, harassing, defamatory, obscene, or otherwise objectionable</li>
      <li>Violates intellectual property rights</li>
      <li>Contains personal or sensitive information about others without their consent</li>
    </ul>

    <p>We reserve the right to remove content that violates these Terms or applicable law.</p>

    <hr />
    <h2>4. Event Access and Participation</h2>
    <p>Snappo may be used to host and access private event feeds. Access to events may require a code or invitation. You agree not to share unauthorized access or impersonate others.</p>

    <hr />
    <h2>5. Prohibited Conduct</h2>
    <p>You agree not to:</p>
    <ul>
      <li>Use the Services for commercial purposes without permission</li>
      <li>Attempt to gain unauthorized access to other user data</li>
      <li>Distribute spam, malware, or other harmful content</li>
      <li>Interfere with the operation or security of the Services</li>
    </ul>

    <hr />
    <h2>6. Intellectual Property</h2>
    <p>Snappo and its logo, brand elements, and platform features are the property of Snappo LLC and protected under intellectual property laws. You may not use our branding without written permission.</p>

    <hr />
    <h2>7. Termination</h2>
    <p>We reserve the right to suspend or terminate your access if you violate these Terms, abuse the platform, or engage in conduct we determine to be harmful.</p>

    <hr />
    <h2>8. Disclaimers and Limitation of Liability</h2>
    <p>The Services are provided "as is" without warranties of any kind. Snappo LLC is not liable for:</p>
    <ul>
      <li>Loss or deletion of uploaded content</li>
      <li>Misuse of content by other users</li>
      <li>Downtime, technical failures, or errors</li>
      <li>Indirect or consequential damages</li>
    </ul>

    <hr />
    <h2>9. Changes to These Terms</h2>
    <p>We may update these Terms from time to time. Continued use of the Services after changes means you accept the revised Terms. Material changes will be communicated via email or in-app notifications when appropriate.</p>

    <hr />
    <h2>10. Governing Law</h2>
    <p>These Terms are governed by the laws of the State of Arizona, without regard to its conflict of laws principles.</p>

    <hr />
    <h2>11. Contact Us</h2>
    <p>For questions about these Terms, please contact:</p>
    <address>
      Snappo LLC<br />
      Maricopa County, Arizona<br />
      📧 <a href="mailto:info@snappo.io">info@snappo.io</a>
    </address>
  </div>
);

export default TermsOfService;